module.exports = __webpack_public_path__ + "prod/1.42.2/img/sueecss-icon.5e31c274.png";